import React from 'react';
import { LSC_BYLINE, LSC_LOGO_PATH, LSC_PRODUCT_NAME } from '../constants';

export type LscLogoVariant = 'nav' | 'hero';

interface LscLogoProps {
  variant?: LscLogoVariant;
  className?: string;
}

const HERO_SIZE = 'h-28 md:h-36 w-auto max-w-lg';

export function LscLogo({ variant = 'nav', className = '' }: LscLogoProps) {
  return (
    <div className={`flex flex-col items-start ${className}`.trim()}>
      {variant === 'nav' ? (
        <span className="font-display text-xl font-bold uppercase leading-[0.95] tracking-wide text-primary-400 block max-w-[200px] break-words">
          {LSC_PRODUCT_NAME}
        </span>
      ) : (
        <img
          src={LSC_LOGO_PATH}
          alt={`${LSC_PRODUCT_NAME} logo`}
          className={HERO_SIZE}
        />
      )}
      {variant === 'nav' && (
        <span className="mt-1 text-[10px] text-secondary-500 tracking-wide">
          {LSC_BYLINE}
        </span>
      )}
    </div>
  );
}

export default LscLogo;
